module.exports = __webpack_public_path__ + "images/factuals-icon-black_e9ee427461df5d1bac603eccd00a5da4.png";